import React, { Component } from "react";
import { connect } from "react-redux";
import { FetchLexisNexisOfflinePost } from "../actions/misActions";
import { toast } from "react-toastify";
var moment = require("moment");

class LexisNexisOfflinePost extends Component {
    constructor(props) {
        super(props);
        this.state = { data_fetched: false, data: null };
    }

    componentDidMount() {
        let es_id = window.location.href.split("es-id=")[1];
        this.props.FetchLexisNexisOfflinePost(es_id, (success, data) => {
            if (success) {
                this.setState({ data_fetched: true, data });
            } else {
                toast.error("Unable to fetch data at the moment");
            }
        });
    }

    renderContent(data) {
        if (data) {
            let splittedData = data._source.post.content.split("\n");
            let index = -1;
            return splittedData.map((elem) => {
                index++;
                return (
                    <p key={index} style={{ margin: "0.5em 0 0.5em 0", fontFamily: "sans-serif", fontSize: "13px", lineHeight: "15px" }}>
                        {elem}
                    </p>
                );
            });
        }
    }

    render() {
        if (this.state.data_fetched) {
            let { data } = this.state;
            return (
                <div className="ln_main_wrapper">
                    <div className="ln_logo_header">
                        <a href="https://20twenty.radarr.com">
                            <img src="https://20twenty.radarr.com/themes/basic/web/images/email_report/20twenty_logo.png" />
                        </a>
                    </div>
                    <div className="ln_title_header">
                        <h3>LEXISNEXIS</h3>
                    </div>
                    <div className="ln_body">
                        <div className="ln_body_header">
                            {data._source.handlers.length && (
                                <div className="ln_publication_name">
                                    <h1>{data._source.handlers[0].value}</h1>
                                </div>
                            )}
                            <div className="ln_publication_date">
                                <p>{moment(data._source.post.published_date).format("dddd, MMMM Do YYYY, h:mm:ss a")}</p>
                            </div>
                            {data._source.languages.length && (
                                <div className="ln_publication_language">
                                    <p>Language: {data._source.languages[0].full_name}</p>
                                </div>
                            )}
                        </div>
                        <hr />
                        <div className="ln_body_content">
                            <h4>{data._source.post.title}</h4>
                            {this.renderContent(data)}
                        </div>
                    </div>
                </div>
            );
        } else {
            return <div>Loading........</div>;
        }
    }
}

function mapStateToProps() {
    return {};
}

export default connect(mapStateToProps, { FetchLexisNexisOfflinePost })(LexisNexisOfflinePost);
